var arrToObj = (arr) => {
  var obj = {};
  arr.forEach((a) => {
    obj[a[0]] = a[1];
  });
  return obj;
};
let types = {
  SELECT_BOX: "select",
  SELECT_BOX2: "select2",
  SELECT_BOX3: "select3",
  SELECT_BOX4: "select4",
  RADIO_BUTTON: "radio_button", 
  INPUT: "input",
  DATE_PICKER: "date_picker",
  CURRENT_TIME: "current_time",
  PASSWORD: "password",
  TEXT_AREA: "text_area",
  CHECKBOX: "checkbox",
  SPACE: "space",
  BUTTON: "button",
};

let arr = [
  { id: "seq_id", label: "Unique Key", type: types.INPUT },
  {
    id: "registration_key",
    label: "登録キー",
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    type: types.INPUT,
  },
  {
    id: "approval_status",
    label: "状態",
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    type: types.SELECT_BOX,
    options: [
      "報告済",
      "申請中",
      "下書中",
      "差戻",
    ],
    table_field_style:{
      "報告済":"color:;",
      "申請中":"color:blue;",
      "下書中":"color:#a0283a",
      "差戻":"color:red;"
    },
    export: {
      enabled: true,
      sequence: 1000,
      inventory_unreport_list_euc:"A",
      inventory_unreport_list_it:"A",
    },
  },
  {
    id: "reporting_period",
    label: "棚卸報告年度区分",
    type: types.SELECT_BOX4,
    api:"/master_inventory_reporting_period/list_reporting_period",
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report_form:"C6"
    }
  },
  {
    id: "created_by",
    label: "報告者",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report_form:"C12",
    }
  },
  {
    id: "contact_person",
    label: "担当者（ﾌﾙﾈｰﾑ）",
    type: types.TEXT_AREA,
    label_length_4:true,
    error_if_blank:true,
    field_style: "height:60px",
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"G",
      inventory_report_form:"C11"
    }
  },
  {
    id: "extension_number",
    label: "内線番号",
    error_if_blank:true,
    type: types.INPUT,
    error_if_blank:true,
    import: { enabled: true },
    export:{
      enabled:true,
    }
  },
  {
    id: "created_date",
    label: "報告日",
    type: types.DATE_PICKER,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    import: { enabled: true },
    export:{
      inventory_report:"F",
      enabled:true,
    }
  },
  {
    id: "last_update_date",
    label: "更新日時",
    type: types.CURRENT_TIME,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    import: { enabled: true },
    export:{
      enabled:true,
    }
  },

 //　1.機器台帳 
  {
    id: "ledger_check",
    label: "機器・ソフトウェア紐付明細の確認",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      "一致", 
      "不一致",
    ],
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"Q",
      inventory_report_form:"F30"
    }
  },
  {
    id: "new_registration_of_equipment",
    label: "機器の新規登録",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      "有", 
      "無",
    ],
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"R",
      inventory_report_form:"F31"
    }
  },
  {
    id: "change_device_information",
    label: "機器情報の変更",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      "有", 
      "無",
    ],
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"S",
      inventory_report_form:"F32"
    }
  },
  {
    id: "disposal_of_device_information",
    label: "機器情報の廃棄",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      "有", 
      "無",
    ],
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"T",
      inventory_report_form:"F33"
    }
  },
  //　2．証書一覧
  {
    id: "certificate_list_check",
    label: "証書一覧の確認",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      "一致", 
      "不一致",
    ],
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"H",
      inventory_report_form:"F17"
    }
  },
  {
    id: "new_license_registration",
    label: "ライセンスの新規登録",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      "有", 
      "無",
    ],
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"I",
      inventory_report_form:"F18"
    }
  },
  {
    id: "change_license_information",
    label: "ライセンス情報の変更",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      "有", 
      "無",
    ],
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"J",
      inventory_report_form:"F19"
    }
  },
  {
    id: "disposal_of_license",
    label: "ライセンスの廃棄",
    type: types.SELECT_BOX,
    error_if_blank:true,
    options: [
      "有", 
      "無",
    ],
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"K",
      inventory_report_form:"F20"
    }
  },
  {
    id: "reason_not_using",
    label: "ライセンスの未使用理由",
    type: types.TEXT_AREA,
    label_length_4:true,
    field_style: "height:100px",
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"M",
      inventory_report_form:"F22"
    }
  },
  {
    id: "expired_license_support",
    label: "期限切れライセンス対応",
    type: types.SELECT_BOX,
    import: { enabled: true },
    options: [
      "　",
      "廃棄もしくは更新予定", 
      "その他(備考に詳細を記入)",
    ],
    export:{
      enabled:true,
      inventory_report:"O",
      inventory_report_form:"F24"
    }
  },
  {
    id: "certificate_remarks",
    label: "証書一覧備考",
    type: types.TEXT_AREA,
    label_length_4:true,
    field_style: "height:100px",
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"P",
      inventory_report_form:"F25"
    }
  },
  //　3.紐付個別明細
  {
    id: "lack_of_license",
    label: "①ライセンス購入数の不足",
    emit_input:true,
    field_type:"number",
    error_if_blank:true,
    min_value: "0",
    field_style:"text-align: right;",
    type: types.INPUT,
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"U",
      inventory_report_form:"F35"
    }
  },
  {
    id: "lost_license_certificate",
    label: "②ライセンス証書の紛失",
    error_if_blank:true,
    emit_input:true,
    field_type:"number",
    min_value: "0",
    field_style:"text-align: right;",
    type: types.INPUT,
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"V",
      inventory_report_form:"F36"
    }
  },
  {
    id: "no_evidence_of_license_receipt",
    label: "③ライセンス証書の受領形跡無し",
    error_if_blank:true,
    emit_input:true,
    field_type:"number",
    min_value: "0",
    field_style:"text-align: right;",
    type: types.INPUT,
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"W",
      inventory_report_form:"F37"
    }
  },
  {
    id: "other",
    label: "④その他",
    emit_input:true,
    field_type:"number",
    error_if_blank:true,
    min_value: "0",
    field_style:"text-align: right;",
    type: types.INPUT,
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"X",
      inventory_report_form:"F38"
    }
  },
  {
    id: "remarks",
    label: "ソフトウェア紐付備考",
    type: types.TEXT_AREA,
    label_length_4:true,
    field_style: "height:100px",
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"Z",
      inventory_report_form:"F39"
    }
  },
  {
    id: "unused_license",
    label: "未使用ライセンス",
    type: types.INPUT,
    read_only: true,
    field_style:"text-align: right;",
    label_style: "background-color: #CCCCCC !important;",
    //listen_for_value: "licence_item_number_force_update",
    field_type:"number",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"L",
      inventory_report_form:"F21"
    }
  },
  {
    id: "expired_license",
    label: "期限切れライセンス",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    field_style:"text-align: right;",
    //listen_for_value: "licence_item_number_force_update",
    field_type:"number",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"N",
      inventory_report_form:"F23"
    }
  },
  {
    id: "admin_remark",
    label: "所見",
    type: types.TEXT_AREA,
    label_length_4:true,
    field_style: "height:100px",
    import: { enabled: true },
    export:{
      inventory_report:"AH",
      enabled:true,
    }
  },
  {
    id: "retraction_reason",
    label: "差戻理由",
    type: types.TEXT_AREA,
    label_length_4:true,
    field_style: "height:100px",
  },
  {
    id: "retraction_person",
    label: "差戻者",
    type: types.INPUT,
    label_length_4:true,
  },
  {
    id: "retraction_person_label",
    label: "差戻者",
    type: types.INPUT,
    label_length_4:true,
  },
  {
    id: "retraction_person_name",
    label: "差戻者",
    type: types.INPUT,
    label_length_4:true,
  },
  {
    id: "number_of_unattached",
    label: "未紐付数",
    type: types.INPUT,
    read_only: true,
    field_style:"text-align: right;",
    label_style: "background-color: #CCCCCC !important;",
    field_type:"number",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report_form:"F34"
    }
  },

  //　報告期分・部署・チーム
  {
    //6
    id: "company",
    label: "会社",
    type: types.SELECT_BOX4,
    page_controller: true,
    api_uniq_grouping:true,
    api: "/master_company/list_company_name",
    export: {
      enabled: true,
      sequence: 1000,
      inventory_report:"D",
      inventory_unreport_list_euc:"B",
    },
  },
  {
    //5
    id: "jurisdiction_classification",
    label: "所管区分",
    type: types.SELECT_BOX,
    options: ["EUC・その他", "IT所管システム"],
    import: { enabled: true },
    api_uniq_grouping:true,
    export: {
      enabled: true,
      sequence: 1000,
    },
  },
  {
    id: "department_in_charge",
    label: "所管部署",
    type: types.SELECT_BOX4,
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    api: "/master_belongs/list_department",
    limit_department_on_search: true,
    // global_emit:"licensed_department_selected",
    page_controller: true,
    api_uniq_grouping:true,
    search_option:{
      define_department_limit_to_key:"report_team"
    },
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"E",
      inventory_report_form:"C8",
      inventory_unreport_list_euc:"C",
      inventory_unreport_list_it:"C",
    }
  },
  {
    id: "team_in_charge",
    label: "所管チーム",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    api: "/master_belongs/list_team_and_department",
    api_field_name: "team",
    api_uniq_grouping:true,
    // sort_result:true,
    limit_department_on_search: true,
    // api_filter_to_other_field:{
    //   by_field:"licensed_department",
    //   compare_api_key:"department",
    //   filter_data_on_event:"licensed_department_selected",
    // },
    page_controller: true,
    read_only: true,
    search_option:{
      define_department_limit_by_key:"report_department",
      api_field_name:"department",
    },
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"C",
      inventory_report_form:"C9",
      inventory_unreport_list_euc:"D",
    }
  },
  {
    id: "reporting_system",
    label: "所管システム",
    type: types.SELECT_BOX4,
    search_mode_type_ahead:true,
    sort_result:true,
    api: "/master_system/list_system_name",
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report:"B",
      inventory_report_form:"C10",
      inventory_unreport_list_it:"B",
    }
  },

  //data

  {
    id: "number_of_registered_devices",
    label: "登録機器台数",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    field_style:"text-align: right;",
    field_type:"number",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"AC",
    }
  },

  {
    id: "number_of_registered_licenses",
    label: "登録ライセンス数",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    field_style:"text-align: right;",
    field_type:"number",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"AD",
    }
  },

  {
    id: "number_of_software_packages_used",
    label: "使用ソフトウェア数",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    field_style:"text-align: right;",
    field_type:"number",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"AE",
    }
  },
  {
    id: "number_of_installed_software_to_be_linked",
    label: "紐付け対象インストールソフト数",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    field_style:"text-align: right;",
    field_type:"number",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"AF",
    }
  },
  {
    id: "number_of_installation_software_licenses_attached",
    label: "インストールソフト-ライセンスの紐付数",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    field_style:"text-align: right;",
    field_type:"number",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"AG",
    }
  },
  {
    id: "linkage_ratio",
    label: "紐付率",
    type: types.INPUT,
    read_only: true, 
    // field_type:"number",
    field_style:"text-align: right;",
    label_style: "background-color: #CCCCCC !important;",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"AA",
    }
  },
  {
    id: "last_linkage_ratio",
    label: "前回紐付率",
    type: types.INPUT,
    read_only: true,
    field_style:"text-align: right;",
    label_style: "background-color: #CCCCCC !important;",
    import: {enabled: true},
    export:{
      enabled:true,
      inventory_report:"AB",
    }
  },

  {
    id: "new_or_resubmit",
    label: "新規/再提出",
    type: types.SELECT_BOX,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    options: [
      "新規", 
      "再提出",
    ],
    import: { enabled: true },
    export:{
    enabled:true,
    inventory_report_form:"C7"
    }
  },
  {
    id: "more_details",
    label: "詳細",
    type: types.INPUT,
  },
  {
    id: "button_options",
    history_label_name: "hide",
    label: "ﾁｪｯｸ",
    type: types.INPUT,
  },
  { id: "a_seq_id", label: "Unique Key", type: types.INPUT },

  {
    id: "syubetu",
    label: "種別",
    type: types.SELECT_BOX,
    options: ["機器・組込情報", "証書情報"],
    import: { enabled: true },
  },
  {
    id: "control_number",
    label: "管理番号",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "toroku_number",
    label: "申請No",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "bulk_toroku_number",
    label: "一括編集No",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "applicant",
    label: "申請者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "applicant_team",
    label: "申請者チーム",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "update_name",
    label: "最終更新者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "next_approver",
    label: "次回承認者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "applicant_label",
    label: "申請者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "update_name_label",
    label: "最終更新者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "next_approver_label",
    label: "次回承認者",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "create_time",
    label: "開始日時",
    type: types.CURRENT_TIME,
    import: { enabled: true },
  },
  {
    id: "update_time",
    label: "更新日時",
    type: types.CURRENT_TIME,
    import: { enabled: true },
  },
  {
    id: "licensed_department",
    label: "ライセンス所管部署",
    type: types.SELECT_BOX4,
    api:"/master_belongs/list_department",
    import: { enabled: true },
  },

  {
    id: "status_0",
    label: "状態0",
    type: types.INPUT,
    import: { enabled: true },
  },
  {
    id: "team_1",
    label: "所属チーム1",
    // type: types.INPUT,
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_1_selected",
    api_uniq_grouping:true,
    import: { enabled: true }
  },
  {
    id: "approver_1",
    label: "承認者1",
    // type: types.INPUT,
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_1_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_1",
      compare_api_key:"team",
      filter_data_on_event:"team_1_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_1",
    label: "状態1",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
  {
    id: "team_2",
    label: "所属チーム2",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_2_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_1_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_2",
    label: "承認者2",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_2_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_2",
      compare_api_key:"team",
      filter_data_on_event:"team_2_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_2",
    label: "状態2",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
  {
    id: "team_3",
    label: "所属チーム3",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_3_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_2_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_3",
    label: "承認者3",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_3_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_3",
      compare_api_key:"team",
      filter_data_on_event:"team_3_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_3",
    label: "状態3",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
  {
    id: "team_4",
    label: "所属チーム4",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_4_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_3_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_4",
    label: "承認者4",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_4_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_4",
      compare_api_key:"team",
      filter_data_on_event:"team_4_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_4",
    label: "状態4",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
  {
    id: "team_5",
    label: "所属チーム5",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_5_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_4_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_5",
    label: "承認者5",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    // global_emit:"approver_5_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_5",
      compare_api_key:"team",
      filter_data_on_event:"team_5_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_5",
    label: "状態5",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
  {
    id: "team_6",
    label: "所属チーム6",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_6_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_5_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_6",
    label: "承認者6",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_6_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_6",
      compare_api_key:"team",
      filter_data_on_event:"team_6_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_6",
    label: "状態6",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_7",
    label: "所属チーム7",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_7_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_6_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_7",
    label: "承認者7",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_7_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_7",
      compare_api_key:"team",
      filter_data_on_event:"team_7_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_7",
    label: "状態7",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_8",
    label: "所属チーム8",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_8_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_7_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_8",
    label: "承認者8",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_8_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_8",
      compare_api_key:"team",
      filter_data_on_event:"team_8_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_8",
    label: "状態8",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_9",
    label: "所属チーム9",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_9_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_8_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_9",
    label: "承認者9",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_9_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_9",
      compare_api_key:"team",
      filter_data_on_event:"team_9_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_9",
    label: "状態9",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_10",
    label: "所属チーム10",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_10_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_9_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_10",
    label: "承認者10",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_10_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_10",
      compare_api_key:"team",
      filter_data_on_event:"team_10_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_10",
    label: "状態10",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
  {
    id: "team_11",
    label: "所属チーム11",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_11_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_10_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_11",
    label: "承認者11",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_11_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_11",
      compare_api_key:"team",
      filter_data_on_event:"team_11_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_11",
    label: "状態11",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_12",
    label: "所属チーム12",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_12_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_11_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_12",
    label: "承認者12",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_12_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_12",
      compare_api_key:"team",
      filter_data_on_event:"team_12_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_12",
    label: "状態12",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_13",
    label: "所属チーム13",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_13_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_12_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_13",
    label: "承認者13",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_13_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_13",
      compare_api_key:"team",
      filter_data_on_event:"team_13_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_13",
    label: "状態13",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_14",
    label: "所属チーム14",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_14_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_13_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_14",
    label: "承認者14",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_14_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_14",
      compare_api_key:"team",
      filter_data_on_event:"team_14_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_14",
    label: "状態14",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_15",
    label: "所属チーム15",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_15_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_14_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_15",
    label: "承認者15",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_15_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_15",
      compare_api_key:"team",
      filter_data_on_event:"team_15_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_15",
    label: "状態15",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
  {
    id: "team_16",
    label: "所属チーム16",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_16_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_15_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_16",
    label: "承認者16",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_16_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_16",
      compare_api_key:"team",
      filter_data_on_event:"team_16_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_16",
    label: "状態16",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_17",
    label: "所属チーム17",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_17_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_16_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_17",
    label: "承認者17",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_17_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_17",
      compare_api_key:"team",
      filter_data_on_event:"team_17_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_17",
    label: "状態17",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_18",
    label: "所属チーム18",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_18_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_17_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_18",
    label: "承認者18",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_18_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_18",
      compare_api_key:"team",
      filter_data_on_event:"team_18_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_18",
    label: "状態18",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_19",
    label: "所属チーム19",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_19_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_18_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_19",
    label: "承認者19",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    global_emit:"approver_19_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_19",
      compare_api_key:"team",
      filter_data_on_event:"team_19_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_19",
    label: "状態19",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
 {
    id: "team_20",
    label: "所属チーム20",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"team",
    global_emit:"team_20_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      filter_data_on_event:"approver_19_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "approver_20",
    label: "承認者20",
    type: types.SELECT_BOX4,
    api:"/master_user/list_user_and_team/",
    api_field_name:"user_id",
    api_field_label:"user_shimei",
    // global_emit:"approver_20_selected",
    api_uniq_grouping:true,
    api_filter_to_other_field:{
      by_field:"team_20",
      compare_api_key:"team",
      filter_data_on_event:"team_20_selected",
      disable_is_no_value:true
    },
    import: { enabled: true },
  },
  {
    id: "status_20",
    label: "状態20",
    type: types.INPUT,
    import: { enabled: true },
    table_field_style:{
      "承認済":"color:;",
      "未承認":"color:blue;",
      "差戻":"color:red;"
    },
  },
  {
    id: "created_by_label",
    label: "報告者",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    import: { enabled: true },
    export:{
      enabled:true,
      inventory_report_form:"C12",
    }
  },
  {
    id: "created_by_name",
    label: "報告者",
    type: types.INPUT,
    read_only: true,
    label_style: "background-color: #CCCCCC !important;",
    import: { enabled: true },
    export:{
      enabled:true,
    }
  },
  {
    id: "approver_1_label",
    label: "承認者1",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_2_label",
    label: "承認者2",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_3_label",
    label: "承認者3",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_4_label",
    label: "承認者4",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_5_label",
    label: "承認者5",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_6_label",
    label: "承認者6",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_7_label",
    label: "承認者7",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_8_label",
    label: "承認者8",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_9_label",
    label: "承認者9",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_10_label",
    label: "承認者10",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_11_label",
    label: "承認者11",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_12_label",
    label: "承認者12",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_13_label",
    label: "承認者13",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_14_label",
    label: "承認者14",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_15_label",
    label: "承認者15",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_16_label",
    label: "承認者16",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_17_label",
    label: "承認者17",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_18_label",
    label: "承認者18",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_19_label",
    label: "承認者19",
    // type: types.INPUT,
    type: types.INPUT,
  },
  {
    id: "approver_20_label",
    label: "承認者20",
    // type: types.INPUT,
    type: types.INPUT,
  },
];
var ret = {};
var s = 1;
arr.forEach(function (e) {
  if(!RegExp("^[a-z][a-z0-9_]+$").test(e.id)){alert("Invalid field " + e.id);};
  e["tab_label"] = e.tab_label || e.label;
  e["seq_id"] = s++;
  ret[e.id] = e;
});
ret.array = arr;
export const fields = ret;
export const filed_types = types;



// WEBPACK FOOTER //
// ./src/rules/fields_inventory_report.js